(function () {
  'use strict';

  const form = document.getElementById('FacetsForm');
  const productGrid = document.querySelector('[data-product-grid]');
  const sortSelect = document.querySelector('[data-sort-select]');
  const filtersToggle = document.querySelector('[data-filters-toggle]');
  const filtersPanel = document.getElementById('CollectionFilters');
  const clearBtn = document.querySelector('[data-clear-filters]');

  function currentUrl() {
    return new URL(window.location.href);
  }

  function fetchAndRender(url) {
    fetch(url.toString())
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newMain = doc.getElementById('CollectionMain');
        const currentMain = document.getElementById('CollectionMain');
        if (newMain && currentMain) {
          currentMain.innerHTML = newMain.innerHTML;
        }
        window.history.pushState({}, '', url.toString());
      })
      .catch(() => {
        window.location.href = url.toString();
      });
  }

  form &&
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-facet-checkbox], input[type="number"]')) return;
      const url = currentUrl();
      const formData = new FormData(form);
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        if (value) params.append(key, value);
      });
      if (sortSelect) params.set('sort_by', sortSelect.value);
      url.search = params.toString();
      fetchAndRender(url);
    });

  sortSelect &&
    sortSelect.addEventListener('change', function () {
      const url = currentUrl();
      url.searchParams.set('sort_by', sortSelect.value);
      fetchAndRender(url);
    });

  clearBtn &&
    clearBtn.addEventListener('click', function () {
      const url = currentUrl();
      url.search = '';
      fetchAndRender(url);
    });

  filtersToggle &&
    filtersToggle.addEventListener('click', function () {
      const isOpen = filtersPanel.classList.toggle('is-open');
      filtersToggle.setAttribute('aria-expanded', isOpen);
    });
})();
